export const loadingSelector = (state) => state.loading;
export const loadingInventoryCountsSelector = (state) =>
	state.loadingInventoryCounts;
export const vehiclesSelector = (state) => state.vehicles;
export const inventoryCountsSelector = (state) => state.inventoryCounts;
export const widgetDataSelector = (state) => state.widgetData;
